<template>
  <div class="user-layout-left-menu">
    <div class="head">
      <div class="logo"><img src="@/assets/images/logo.png" />
      </div>
    </div>
    <div class="menu">
      <div class="children-menu">
        <div class="item" @click="dialogVisible = true"><img src="@/assets/images/user/ts.png" />
          <div class="item-title">探索</div>
        </div>
        <div @click="redirect('/apply/index')"
          :class="{ 'item': true, 'item-active': $route.path.startsWith('/apply/') }"><img
            :src="require($route.path.startsWith('/apply/') ? '@/assets/images/user/yy_on.png' : '@/assets/images/user/yy.png')" />
          <div class="item-title">应用</div>
        </div>
        <div :class="{ 'item': true, 'item-active': $route.path.startsWith('/agent/') }"
          @click="redirect('/agent/index')"><img
            :src="require($route.path.startsWith('/agent/') ? '@/assets/images/user/znt_on.png' : '@/assets/images/user/znt.png')" />
          <div class="item-title">智能体</div>
        </div>
        <el-divider></el-divider>
        <div :class="{ 'item': true, 'item-active': $route.path.startsWith('/home/') }"
          @click="redirect('/home/index')"><img
            :src="require($route.path.startsWith('/home/') ? '@/assets/images/user/home_on.png' : '@/assets/images/user/home.png')" />
          <div class="item-title">个人空间</div>
        </div>
        <div :class="{ 'item': true, 'item-active': $route.path.startsWith('/chat/') }" @click="redirect('/chat')"><img
            src="@/assets/images/user/zs.png" />
          <div class="item-title">助手</div>
        </div>
        <div :class="{ 'item': true, 'item-active': $route.path.startsWith('/knowledge') }"
          @click="redirect('/knowledge/index')">
          <img
            :src="require($route.path.startsWith('/knowledge') ? '@/assets/images/user/zsk_on.png' : '@/assets/images/user/zsk.png')" />
          <div class="item-title">知识库</div>
        </div>
      </div>
    </div>
    <div class="botom">
      <el-dropdown trigger="click" @command="handleCommand">
        <div class="user-info">
          <div class="text-avatar">
            {{ avatarText }}
          </div>
          <span>{{ userInfo.name }}</span>
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="toAdmin" v-if="isAdmin">管理后台</el-dropdown-item>
          <el-dropdown-item>个人信息</el-dropdown-item>
          <el-dropdown-item command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <create-agent :visible.sync="dialogVisible" @created="onAppCreated"></create-agent>
  </div>
</template>

<script>
import CreateAgent from '@/components/CreateAgent/index.vue';
export default {
  name: 'MenuItem',
  components: {
    CreateAgent
  },
  computed: {
    avatarText() {
      return this.getAvatarText(this.userInfo.name)
    },
    isAdmin() { 
      const userInfo = this.$store.state.user.userInfo;
      if (userInfo.role_ids && userInfo.role_ids.includes(1)) {
        return true;
      }
      return false;
    }
  },
  data() {
    return {
      dialogVisible:false,
      userInfo: this.$store.getters['user/userInfo']
    }
  },
  methods: {
    redirect(path) {
      this.$emit('closeMenu');
      this.$router.push(path);
    },
    getAvatarText(name) {
      if (!name) return '';

      // Remove any whitespace
      const cleanName = name.trim();

      // For two-character names, return both characters
      if (cleanName.length === 2) {
        return cleanName;
      }

      // For names with 3 or more characters, return the last two
      if (cleanName.length >= 3) {
        return cleanName.slice(-2);
      }

      // For single character names, just return that character
      return cleanName;
    },
    handleCommand(command) {
      if (command === 'logout') {
        this.handleLogout();
      }
      if (command === 'toAdmin') { 
        window.open('/#/feature','_blank')
      }
    },
    handleLogout() {
      // 调用退出登录的方法，具体实现可能需要调用 store action
      this.$store.dispatch('user/logout').then(() => {
        this.$router.push('/login')
      })
    },
    onAppCreated(id) {
      // 应用创建成功后的回调
      this.$router.push({
        path: '/agent/index'
      });
    },
  }
}
</script>
<style lang="scss" scoped>
.user-layout-left-menu {
  height: 100%;
  width: 240px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  //border-right: 1px solid #eaeaea;
  box-sizing: border-box;

  .head {
    margin-bottom: 10px;

    .logo {
      width: 145px;
      margin-bottom: 25px;
      cursor: pointer;

      img {
        width: 100%;
      }
    }
  }

  .menu {
    flex: 1;
    overflow-y: auto;
    display: flex;
    justify-content: center;

    .children-menu {
      color: #1E1F24;
      font-size: 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 120px;

      .item {
        padding: 10px 0;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        cursor: pointer;
        gap: 12px;
        margin-bottom: 13px;
        width: 100%;
        color: #565772;

        img {
          width: 24px;
          height: 24px;
          flex-shrink: 0;
        }

        .item-title {
          font-size: 16px;
          text-align: left;
          font-family: PingFang SC, PingFang SC;
          line-height: 22px;
          font-style: normal;
          text-transform: none;
          white-space: nowrap;
        }
      }

      .item-active {
        color: #1677FF;
      }
    }
  }

  .botom {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px;
    justify-content: center;
    padding-right:25px;
    img {
      width: 25px;
      height: 25px;
      border-radius: 50%;
    }

    .user-info {
      display: flex;
      align-items: center;
      cursor: pointer;

      .text-avatar {
        margin-right: 8px;
      }

      .el-icon-caret-bottom {
        margin-left: 4px;
        font-size: 12px;
      }
    }
  }
}

.text-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #1677FF;
  color: white;
  font-weight: bold;
  font-size: 12px;
  user-select: none;
}
</style>
